export enum InspectionStatus {
    Accepted,
    Rejected
  }